<template lang="pug">
section
  s-page-title(title='FAQ группы')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.name }}
          td(class='checkbox-wrap')
            v-checkbox(
              v-model='props.item.show_on_faq_page'
              color='primary'
              readonly
            )          

          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='dictionary/faqgroups'
            )
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Название группы',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Для страницы FAQ',
        align: 'left',
        sortable: false,
        value: 'show_on_faq_page'
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'dictionary/faqgroups',
      itemValue: 'id',
      itemText: 'name'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Seo.FaqGroups.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    ...mapActions('seo/faqGroups', ['fetchList', 'destroy']),
    ...mapMutations('seo/faqGroups', ['setDataFilter'])
  },

  computed: {
    ...mapState('seo/faqGroups', ['total', 'dataFilter']),
    ...mapGetters('seo/faqGroups', ['list', 'isLoading']),
  }
}
</script>
